import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import AppPage from '../../views/AppPage/';
const GLOBAL = require('../../Globals');

class VersionSetup extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			vid : '',
			proname : '',
			doname : '',
			vername : '',
			vercode : '',
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
  
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
			PostData('mobileapi/updatedomainversion',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Setup Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		// }
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('mobileapi/getversioncontrol').then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				
				this.setState({
					vid :  res[0]['id'],
					proname : res[0]['projectname'],
					doname : res[0]['domainname'],
					vername : res[0]['versionname'],
					vercode : res[0]['versioncode']
				});
				
			}
			
		});
	}
	
  render() {
	

    return (
		<div>
		  <AppPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			  <form action="" method="post" role="form" id="versetup" encType="multipart/form-data" onSubmit={this.onSubmit} >
			
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Mobile Version Setup</strong>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="1">
								<FormGroup>
								  <Label htmlFor="name">Project Name</Label>
								</FormGroup>
							</Col>
							<Col md="4">
								<FormGroup>
								  <Input type="text" name="proname" onChange={this.onChange} value={this.state.proname}/>
								</FormGroup>
							</Col>
							<Col md="1">
								<FormGroup>
								  <Label htmlFor="name">Domain Name</Label>
								</FormGroup>
							</Col>
							<Col md="5">
								<FormGroup>
								  <Input type="text" name="doname" onChange={this.onChange} value={this.state.doname}/>
								</FormGroup>
							</Col>
							<Col md="1"></Col>
							<Col md="1">
								<FormGroup>
								  <Label htmlFor="name">Version Name</Label>
								</FormGroup>
							</Col>
							<Col md="4">
								<FormGroup>
								  <Input type="text" name="vername" onChange={this.onChange} value={this.state.vername}/>
								</FormGroup>
							</Col>
							<Col md="1">
								<FormGroup>
								  <Label htmlFor="name">Version Code</Label>
								</FormGroup>
							</Col>
							<Col md="5">
								<FormGroup>
								<Input type="text" name="vercode" onChange={this.onChange} value={this.state.vercode}/>
								</FormGroup>
							</Col>
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary" className="btn-right" ><i className="fa fa-dot-circle-o"></i> Save</Button>
						</CardFooter>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default VersionSetup;


// WEBPACK FOOTER //
// ./src/app/VersionSetup/VersionSetup.js